import { t as e } from "../../constants-B7fXbm2f.js";
import { t } from "../../_plugin-vue_export-helper-B52Kst-M.js";
import { createElementBlock as n, createElementVNode as r, normalizeClass as i, openBlock as a } from "vue";
//#region ../src/icons/hourglass.vue
var o = {
	name: "DtIconHourglass",
	props: {
		size: {
			type: String,
			default: "500",
			validator: (t) => Object.keys(e).includes(t)
		},
		ariaLabel: {
			type: String,
			default: void 0
		}
	},
	emits: ["loaded"],
	computed: {
		iconSizeClass() {
			return e[this.size];
		},
		ariaHidden() {
			return this.ariaLabel ? "false" : "true";
		},
		dataQA() {
			return this.$attrs["data-qa"] ?? "dt-icon";
		}
	},
	created() {
		this.$emit("loaded");
	}
}, s = [
	"aria-label",
	"data-qa",
	"aria-hidden"
];
function c(e, t, o, c, l, u) {
	return a(), n("svg", {
		"aria-label": o.ariaLabel,
		class: i([u.iconSizeClass, "d-icon d-icon--hourglass"]),
		"data-qa": u.dataQA,
		"aria-hidden": u.ariaHidden,
		role: "img",
		"data-name": "Hourglass",
		viewBox: "0 0 12 12",
		xmlns: "http://www.w3.org/2000/svg"
	}, [...t[0] || (t[0] = [r("path", {
		"fill-rule": "evenodd",
		"clip-rule": "evenodd",
		d: "M2.5 10.5a.5.5 0 0 0 0 1h7a.5.5 0 0 0 0-1H9V8.914a1.5 1.5 0 0 0-.44-1.06L6.707 6l1.854-1.853A1.5 1.5 0 0 0 9 3.086V1.5h.5a.5.5 0 0 0 0-1h-7a.5.5 0 0 0 0 1H3v1.586c0 .398.158.78.44 1.06L5.292 6 3.439 7.853A1.5 1.5 0 0 0 3 8.914V10.5h-.5ZM4 3.086a.5.5 0 0 0 .146.353L6 5.293l1.853-1.854A.5.5 0 0 0 8 3.086V1.5H4v1.586ZM7.854 8.56A.5.5 0 0 1 8 8.914V10.5H4V8.914a.5.5 0 0 1 .147-.353L6 6.707l1.854 1.854Z",
		fill: "currentColor"
	}, null, -1)])], 10, s);
}
var l = /* @__PURE__ */ t(o, [["render", c]]);
//#endregion
export { l as default };

//# sourceMappingURL=hourglass.js.map